import {HPButton} from '@hconnect/uikit/src/lib2'
import {dataTestId} from '@hproduce/suite-core'
import {TuneOutlined} from '@mui/icons-material'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {useOptimizerSettings} from '../../hooks'
import {useDialog} from '../../providers'

import {OptimizerSettingsDialogContent} from './OptimizerSettingsDialogContent'

export const OptimizerSettingsButton = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {openDialog} = useDialog()

  const {data: optimizerSettings} = useOptimizerSettings()

  const handleOpenSettings = useCallback(() => {
    openDialog({
      header: {title: t('optimizer.optimizerSettings')},
      content: <OptimizerSettingsDialogContent />,
      dataTestId: 'optimizer_settings_dialog'
    })
  }, [openDialog, t])

  return (
    <HPButton
      {...dataTestId('optimizer_settings_button')}
      backgroundMode="medium"
      startIcon={<TuneOutlined />}
      onClick={handleOpenSettings}
      disabled={!optimizerSettings}
    >
      {t('optimizer.settings')}
    </HPButton>
  )
}
